import { FC, useEffect, useState } from "react";
import { routes } from "../../App";
import { useGetAgentStateQuery } from "../../redux/apis/blenderApi";
import LayoutWithNav from "../layouts/LayoutWithNav";
import ActiveCallScreen from "../presenters/ActiveCallScreen";
import AppConflictScreen from "../presenters/AppConflictScreen";
import FullScreenSpinner from "../presenters/FullScreenSpinner";
import IdleAndBreak from "./IdleAndBreak";
import SideMenu from "./SideMenu";

const MainContainer: FC = () => {
  const { data: agentState, isLoading, refetch } = useGetAgentStateQuery();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(
    () => {
      void refetch();

      const interval = setInterval(() => {
        void refetch();
      }, 30000);

      return () => clearInterval(interval);
    },
    [refetch],
  );

  if (isLoading || !agentState)
    return (
      <FullScreenSpinner />
    );

  if (agentState.sessionType === "Desktop")
    return (
      <AppConflictScreen onRefresh={() => void refetch()} />
    );

  if (agentState.state === "Busy")
    return (
      <ActiveCallScreen stateSince={agentState.stateSince} />
    );

  if (agentState.state === "Idle" || agentState.state === "Break")
    return (
      <LayoutWithNav
        displayMenuButton={true}
        mainContent={<IdleAndBreak />}
        menuContent={<SideMenu activeTabKey={routes.home} allowBusinessUnitSelection={agentState.allowBusinessUnitSelection} onCloseMenu={() => setIsMenuOpen(false)} />}
        onBusinessUnitsPage={false}
        agentState={agentState.state}
        isMenuOpen={isMenuOpen}
        onMenuOpenChange={setIsMenuOpen}
      />
    );
};

export default MainContainer;
